/**
* directives.auth Module
*
* Description
*/
var app = angular.module('directives.authentication', []);
	require('./directives/registration.directive.js');
	require('./directives/loginForm.directive.js');
	require('./directives/phoneInput.directive.js');
	require('./stylesheet/loginForm.scss');
	require("./stylesheet/_registration.scss");

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/authentication/index.js
 ** module id = 127
 ** module chunks = 1
 **/